import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getAllResolutions = api(async function allScheduleResolutions() {
    return query(
        gql`
            query GetAllScheduleResolutions {
                allScheduleResolutions
            }
        `,
        {},
        { returns: "allScheduleResolutions" }
    )
})
